import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as sessionModel } from '$/session'
import { model as config, remote } from '@/config'
import { combine } from 'effector'

const $copyrightText = combine(i18n.$t, ({ t }) => t('footer_copyright_text'))

const $privacyPolicy = combine(i18n.$t, ({ t }) => t('privacy_policy'))

const $termsOfAgreement = combine(i18n.$t, ({ t }) => t('terms_of_agreements'))

const $promoText = combine(i18n.$t, ({ t }) => t('footer_promo_text'))

const $isFooterVisible = config.get(remote.tria_isFooterEnabled)

register($privacyPolicy, '$privacyPolicy')
register(sessionModel.$hasToa, '$hasToa')
register($termsOfAgreement, '$termsOfAgreement')
register($copyrightText, '$copyrightText')
register($promoText, '$promoText')
register($isFooterVisible, '$isFooterVisible')
